export default "__VITE_ASSET__BcAJWAAj__"